"use client";

import Header from "../../../components/admin/common/Header";
import PageWrapper from "../../../components/admin/common/PageWrapper";
import Sidebar from "../../../components/admin/common/Sidebar";
import AddForm from "../../../components/admin/members/AddForm";

const AddMember = () => {
  return (
    <div className="flex h-screen p-4 gap-4 bg-white overflow-hidden">
      <div className="h-full">
        <Sidebar />
      </div>

      <div className="flex-1 h-full bg-[#F3EFFF] rounded-[27px] overflow-hidden">
        <PageWrapper>
          <div className="flex flex-col h-full">
            <div className="flex-1 p-4 overflow-y-auto">
              <Header title="Add New Member" desc="Here you can add member" />
              <AddForm />
            </div>
          </div>
        </PageWrapper>
      </div>
    </div>
  );
};

export default AddMember;
